import { useState, useEffect } from 'react';
import { logo } from '../assets/images/images';
// import { burger } from './../assets/images/images';
// import Icon from './Icon';
import { categories, getCategoryProducts } from '../utils/categories';

function Overlay(props) {
  const [selectedCategory, setSelectedCategory] = useState('pasta');
  const [products, setProducts] = useState(null);
  // if (!props.data) return <div></div>;
  // GET CATEGORY PRODUCTS
  useEffect(() => {
    setProducts(getCategoryProducts(selectedCategory));
  }, [selectedCategory]);
  useEffect(() => {
    setSelectedCategory(props.category);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // CHANGE CATEGORY NAME
  const changeCategory = (name) => {
    setSelectedCategory(name);
  };
  return (
    <div className='flex relative bg-white'>
      {/* LEFT SECTION */}
      <div className='basis-[20rem] h-[90vh] self-start sticky left-0 top-0 p-4 bg-[#fbfbfb] '>
        <img src={logo} alt='logo' className='w-[8rem] my-4 mx-auto' />
        <div className='p-2 bg-[#EFEFEF] text-center mb-4 self-stretch rounded-lg'>
          <h2 className='font-[600]'>Food Category</h2>
        </div>
        <div>
          {categories.map((el, id) => {
            return (
              <button
                onClick={() => changeCategory(el)}
                className={`flex gap-2 justify-center w-full ${
                  el === selectedCategory ? 'font-semibold text-black' : null
                }`}
                key={id}
              >
                <p className='text-black/50 mb-2 capitalize'>{el}</p>
              </button>
            );
          })}
        </div>
      </div>
      {/* RIGHT SECTION */}
      <div className='flex-1 m-8'>
        <h2 className='font-[600] mb-4 capitalize text-xl'>
          {selectedCategory}
        </h2>
        <p className='text-black/70 mb-7'>
          What delicious meal are you craving today?
        </p>

        {/* MAIN PRODUCTS */}
        <div className='grid xl:grid-cols-3 lg:grid-cols-2 gap-8'>
          {products &&
            products.map((el, id) => {
              return <ProductCard key={id} data={el} />;
            })}
        </div>
      </div>
    </div>
  );
}

function ProductCard(props) {
  return (
    <div className='border-[1px] text-center border-red-100 rounded-md p-2 pt-12 pb-6 shadow-xl'>
      <div>
        <img
          src={props.data.image}
          alt='burger'
          className='w-20 h-20 block rounded-full mx-auto'
        />
      </div>
      <h2 className='font-[600] capitalize text-lg text-center mt-3 font-Poppins'>
        {props.data.name}
      </h2>
      <p className='text-sm mt-4 text-black/70'>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
      </p>
      <div className='flex justify-evenly mt-4 gap-3 items-center'>
        <h2 className='font-[700] text-sm  '>Rs 1000.00</h2>
        <button className='capitalize text-[#06E775] font-semibold'>
          Add to cart
        </button>
      </div>
    </div>
  );
}

export default Overlay;
